/**
 * Route for `cap-utilization-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapUtilizationWidgetPage } from "../features/cap-utilization-widget/CapUtilizationWidgetPage";

export const capUtilizationWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-utilization-widget",
	component: CapUtilizationWidgetPage,
});

export default capUtilizationWidgetRoute;
